import { render, staticRenderFns } from "./AuditMessagesTable.vue?vue&type=template&id=6a8f44a4&"
import script from "./AuditMessagesTable.vue?vue&type=script&lang=ts&"
export * from "./AuditMessagesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VScrollYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VContainer,VDataTable,VScrollYReverseTransition})
